import get from 'lodash/get';

export default function(state = {}, action) {
  const typeMap = {
    TAG_PROMOTER_CHANNEL_FC_WORKS_LOADING() {
      return {
        isLoading: true,
        tagPromoterChannelFcWorks: action.tagPromoterChannelFcWorks
      };
    },
    TAG_PROMOTER_CHANNEL_FC_WORKS_LOADED() {
      return {
        isLoading: false,
        channelFcWorksPosts: get(
          action,
          'tagPromoterChannelFcWorks.channelFcWorksPosts'
        ),
        source: get(action, 'tagPromoterChannelFcWorks.source')
      };
    },
    TAG_PROMOTER_CHANNEL_FC_WORKS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.channelFcWorksPosts.errorMessage,
        channelFcWorksPosts: []
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
